<template>
  <div class="current-study-container">
    <div class="current-study">
      <template v-if="current">
        <span class="subtitle">We're currently studying</span>
        <span class="h2 mb-10"> {{ current.title }} </span>

        <app-button
          :to="{ name: 'art-club-study', params: { id: current.id } }"
          class="mb-6"
          variant="cta"
          align="center"
          >Participate</app-button
        >
        <span class="small">
          <app-date :date="current.deadline" prepend="Deadline" />
        </span>
      </template>
      <failed-to-load v-else />
    </div>
    <img class="blob" src="~@/assets/images/blob-1.svg" alt="" />
    <img class="circle" src="~@/assets/images/circle-1.svg" alt="" />
  </div>
</template>

<script>
import FailedToLoad from '@/components/global/FailedToLoad';
import AppDate from '@/components/app/AppDate';

export default {
  name: 'CurrentStudy',
  components: { FailedToLoad, AppDate },
  computed: {
    current() {
      if (this.$store.state.studies.list === null) return;
      return this.$store.state.studies.list[0];
    },
  },
};
</script>

<style lang="scss" scoped>
.current-study-container {
  width: 560px;
  max-width: 100%;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  display: flex;

  .circle {
    position: absolute;
    bottom: 0;
    transform: translate(-40%, -100%);
    user-select: none;
    pointer-events: none;
  }

  .blob {
    position: absolute;
    top: -160px;
    right: -120px;
    user-select: none;
    pointer-events: none;
  }

  @media screen and (min-width: 1024px) {
    .circle,
    .blob {
      display: block;
    }
  }
}

.current-study {
  background: rgba(255, 255, 255, 0.93);
  backdrop-filter: blur(8px);
  display: flex;
  flex-direction: column;
  z-index: 20;
  text-align: center;
  align-items: center;
  box-shadow: 0 8px 24px 0px rgba(black, 0.06);
  padding: 2rem 1rem;
  @media screen and (min-width: 1024px) {
    border-radius: 16px;
    padding: 56px 64px;
  }
  flex: 1;
}
</style>
